function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M2.631 4.912a.5.5 0 01.707-.03L12 12.821l8.662-7.94a.5.5 0 01.676.737l-9 8.25a.5.5 0 01-.676 0l-9-8.25a.5.5 0 01-.03-.707z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M2.5 5.25a.5.5 0 01.5-.5h18a.5.5 0 01.5.5V18a1.25 1.25 0 01-1.25 1.25H3.75A1.25 1.25 0 012.5 18V5.25zm1 .5V18a.25.25 0 00.25.25h16.5a.25.25 0 00.25-.25V5.75h-17z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M10.732 11.662a.5.5 0 01-.03.707l-7.133 6.538a.5.5 0 11-.675-.738l7.132-6.538a.5.5 0 01.706.031zM13.268 11.662a.5.5 0 01.706-.03l7.133 6.537a.5.5 0 01-.676.738l-7.133-6.538a.5.5 0 01-.03-.707z"
});
function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}
export default SvgEnvelope;